import { render, staticRenderFns } from "./WorkflowPhaseEditor.vue?vue&type=template&id=f623da8c&scoped=true&"
import script from "./WorkflowPhaseEditor.vue?vue&type=script&lang=ts&"
export * from "./WorkflowPhaseEditor.vue?vue&type=script&lang=ts&"
import style0 from "./WorkflowPhaseEditor.vue?vue&type=style&index=0&id=f623da8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f623da8c",
  null
  
)

export default component.exports